import { Pipe, PipeTransform } from '@angular/core';
import {User} from "@twilio/conversations";

@Pipe({
  standalone: false,
  name: 'chatConversationNamePipe'
})
export class ChatConversationNamePipe implements PipeTransform {

  transform(users: User[]): unknown {

    if (users?.length) {
      const names = users.map((u: User, index: number) => {
        // @ts-ignore
        return `${u.attributes?.fullName || 'N/A'}${index < (users.length - 1) ? ', ' : ''}`
      })
      return names;
    } else {
      return '';
    }

  }

}
